import type { StyleSheet } from "react-native";

import type { Theme } from "../../mads/ThemeProvider";

// TODO - RN-3061: Move this function to apps/mads.
//     This is a temporary home until it can land in MADs; it lives in apps/shared/util
//     to avoid triggering MADs code review during a time crunch.
export const createThemedStylesheet = <T extends StyleSheet.NamedStyles<T>>(
  factory: (theme: Theme) => T,
): ((theme: Theme) => T) => factory;
